// @flow

import {getLocationPostcode} from "../location-cookie";
import initPrices from "../product-pricing";
import {hidePostCodePopup} from "../raw-from-relab/popup-postcode";
import {updateProductButtonStates} from "../add-to-cart";

const POSTCODE_UPDATED = "postcode-update__postcode-updated";

type EventDetail = {
    detail: {
        postcode: {
            postCode: string
        }
    },
};

const updatePostCodeHeader = (winProxy, postcode) => {
    const headerPostcode = winProxy.document.querySelector(`.postcode-link`);
    if (headerPostcode){
        headerPostcode.innerText = postcode;
    }
}

const showPostcodeLinkButton = function (node: HTMLElement) {
    node.classList && node.classList.remove(`hidden`);
}

const hidePostcodeLinkButton = function (node: HTMLElement) {
    node.classList && node.classList.add(`hidden`);
}


export const listenForSubmissionEvent = function(event: Event) {
    event.preventDefault();
};

export const handleSuccess = async (winProxy: WindowProxy, postcodeLinks: HTMLElement[], successEvent: EventDetail) => {
    await initPrices(winProxy);
    updatePostCodeHeader(winProxy, successEvent.detail.postcode.postCode);
    postcodeLinks.forEach(hidePostcodeLinkButton);
    hidePostCodePopup();
    
    // Update button states after prices are refreshed
    setTimeout(() => {
        updateProductButtonStates(winProxy);
    }, 100);
};

export function initPostcodeUpdater(winProxy: WindowProxy) {
    //encodeCorrectlyAndStoreLocationCookie();
    const postcode = getLocationPostcode();
    const hasPostcode = !!postcode;
    const form = winProxy.document.querySelector(`.popup-postcode__form`);
    const postcodeLinks = winProxy.document.querySelectorAll(`.product-tile__postcode-link-container`);

    if (hasPostcode) {
        updatePostCodeHeader(winProxy, postcode)
    } else {
        postcodeLinks.forEach(showPostcodeLinkButton);
    }

    form.addEventListener(`submit`, listenForSubmissionEvent);
    winProxy.addEventListener(POSTCODE_UPDATED, handleSuccess.bind(null, winProxy, postcodeLinks));
}
